// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2IrNC","productName":"Table_productName__3y0UE"};